// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".post-section-3[data-v-5b0f7a8a] {\n  padding: 1.5rem 0;\n}\n@media (max-width: 768px) {\n.post-section-3[data-v-5b0f7a8a] {\n    padding: 1rem 0;\n}\n}\n.post-section-3 img[data-v-5b0f7a8a] {\n  width: 100%;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
